import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["square", "variant", "shadow", "space", "children"];
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Button } from '../Button';
import { SpaceVariant, SpacerDirection } from '../Spacer';
import { SquareButtonVariant } from './SquareButton.decl';
import { square, makeSquareButtonVariant, shouldForwardProp } from './utils';
var SquareButtonContainer = styled(Button).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "SquareButton__SquareButtonContainer",
  componentId: "sc-sidykz-0"
})(["", " ", " padding:0;"], makeSquareButtonVariant, square);
export var SquareButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$square = _ref.square,
      square = _ref$square === void 0 ? '80px' : _ref$square,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? SquareButtonVariant.DEFAULT : _ref$variant,
      _ref$shadow = _ref.shadow,
      shadow = _ref$shadow === void 0 ? true : _ref$shadow,
      _ref$space = _ref.space,
      space = _ref$space === void 0 ? SpaceVariant.XXXS : _ref$space,
      children = _ref.children,
      otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(SquareButtonContainer, _extends({
    ref: ref,
    square: square,
    variant: variant,
    shadow: shadow,
    space: space,
    direction: SpacerDirection.VERTICAL
  }, otherProps), children);
});